import { $apiV1 } from "../../../../config/api";

// In-memory cache of object URLs keyed by the exact spoken text, so replaying a
// step (or reopening the tour) within a session never refetches. The backend
// additionally caches the synthesized audio on disk (keyed by model + voice +
// input), so the AI is called at most once per unique card across all users.
const audioUrlCache = new Map();

export const TUTORIAL_MUTED_KEY = "tutorial_muted";

export const isTutorialMuted = () => {
  try {
    return localStorage.getItem(TUTORIAL_MUTED_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const setTutorialMuted = (muted) => {
  try {
    localStorage.setItem(TUTORIAL_MUTED_KEY, muted ? "1" : "0");
  } catch (e) {
    /* ignore storage failures */
  }
};

/**
 * Fetch (or reuse) the spoken-audio object URL for a tutorial card's text via the
 * cached backend TTS endpoint.
 * @param {string} text
 * @returns {Promise<string>} object URL for an audio blob
 */
export const getTutorialSpeechUrl = async (text) => {
  if (audioUrlCache.has(text)) {
    return audioUrlCache.get(text);
  }

  const response = await $apiV1.post(
    "/ai/speech/cached",
    { model: "tts-1", voice: "nova", input: text },
    { responseType: "blob", timeout: 30000 }
  );

  const url = URL.createObjectURL(response.data);
  audioUrlCache.set(text, url);
  return url;
};
